<template>
  <div class="cluster-select" :class="{ 'cluster-select--open': isOpen }">
    <input
      v-if="isOpen"
      v-model="search"
      class="cluster-select__input"
      placeholder="Поиск"
      @keydown.esc.stop.prevent="closeOptions"
    >
    <input
      v-else
      v-model="labelx"
      v-bind="$attrs"
      class="cluster-select__input"
      placeholder="Все ЖК"
      readonly
      v-on="listeners"
    >
    <i-arrow-bottom class="cluster-select__icon" @click="toggle" />
    <recycle-scroller
      v-if="isOpen && filteredItems.length"
      ref="selectMenu"
      class="cluster-select__menu scroller"
      style="max-height: 288px;"
      :items="filteredItems"
      :item-size="36"
      :key-field="trackBy"
      :buffer="20"
    >
      <template v-slot="{ item, index }">
        <div
          class="cluster-select__menu-item"
          :class="{ 'cluster-select__menu-item--selected': item[trackBy] === valuex }"
          @click.stop="clickOption(item[trackBy], item[label], index)"
        >
          <p>{{ item[label] }}</p>
          <i-check v-if="item[trackBy] === valuex" class="ml-auto" />
        </div>
      </template>
    </recycle-scroller>
    <div v-show="isOpen && !filteredItems.length" class="cluster-select__menu">
      <p class="px-4">
        {{ noData }}
      </p>
    </div>
  </div>
</template>

<script>
import { RecycleScroller } from 'vue-virtual-scroller';
import ICheck from '@/assets/svg/icons/check-big.svg';
import IArrowBottom from '@/assets/svg/icons/arrow-small-bottom.svg';

export default {
  name:       'ClusterSelect',
  components: {
    RecycleScroller,
    ICheck,
    IArrowBottom,
  },
  props: {
    value: {
      type:     [Number, String],
      required: true,
    },
    data: {
      type:     Array,
      required: true,
    },
    noData: {
      default: 'Элемент не найден',
      type:    String,
    },
    trackBy: {
      default: 'value',
      type:    String,
    },
    label: {
      default: 'label',
      type:    String,
    },
  },
  data() {
    return {
      items:  JSON.parse(JSON.stringify(this.data)),
      search: '',
      valuex: this.value,
      labelx: this.data[0][this.label],
      isOpen: false,
    };
  },
  computed: {
    filteredItems() {
      if (!this.search) return this.items;

      const lowerCaseSearch = this.search.toLowerCase();
      return this.items.filter((i) => i[this.label].toLowerCase().includes(lowerCaseSearch));
    },
    listeners() {
      return {
        ...this.$listeners,
        blur: (event) => {
          if (
            event.relatedTarget
              ? !event.relatedTarget.closest('.cluster-select__menu')
              : false
          ) {
            this.closeOptions();
            this.$emit('blur', event);
          }
        },
        focus: (event) => {
          this.$emit('focus', event);
          this.isOpen = true;

          setTimeout(() => {
            document.addEventListener('click', this.clickBlur);
          }, 100);
        },
      };
    },
  },
  watch: {
    data(items) {
      this.items = JSON.parse(JSON.stringify(items));

      this.setLabel();
    },
    value(value) {
      this.valuex = this.value;
      this.$emit('change', value);

      if (this.data.length < 2) return;

      this.labelx = this.data.find((item) => item[this.trackBy] === value)[this.label] || this.labelx;
      this.$emit('getLabel', this.labelx);
    },
  },
  methods: {
    /**
     * При иницилизаций вставляет нужный label
     */
    setLabel() {
      if (this.value !== undefined && this.data && this.data.length > 1) {
        const selectedIndex = this.data.findIndex((item) => item[this.trackBy] === this.value);

        if (selectedIndex < 0) return;

        this.labelx = this.data[selectedIndex][this.label];
      }
    },

    /**
     * Открытие / закрытие
     */
    toggle() {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        document.addEventListener('click', this.clickBlur);
      } else {
        document.removeEventListener('click', this.clickBlur);
      }
    },

    /**
     * Закрывает меню и удаляет событие clickBlur из экрана
     */
    closeOptions() {
      this.isOpen = false;
      document.removeEventListener('click', this.clickBlur);
    },

    /**
     * Событие при клика за пределом меню, при клике закрывает меню
     *
     * @param {Event} event
     */
    clickBlur(event) {
      const closestx = event.target.closest('.cluster-select');

      if (!closestx) {
        this.closeOptions();
      }
    },

    /**
     * Присваеваем значение, после выбора в select
     *
     * @param {Number | String} value - значение
     * @param {String} label - текст значение
     */
    clickOption(value, label) {
      this.valuex = value;
      this.labelx = label;
      this.isOpen = false;
      this.search = '';

      this.$emit('input', this.valuex);
    },
  },
};
</script>
